import Header from './Header';
import Footer from './Footer';

function Layout({ children, user }) {
  return (
    <div className="min-h-screen flex flex-col bg-white text-blue-900 font-sans">
      <Header user={user} />
      {/* Main uten max-w og uten padding */}
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
}

export default Layout;
